// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"48fab323","353":"f8c01266","531":"560d7353","680":"34c3849c","705":"d0679732","787":"871b41c3","888":"79947e55","931":"8ceae432"}[chunkId] + ".chunk.js";
};